"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const react_if_1 = require("react-if");
const react_2 = require("@osmosys/react");
exports.OsmosysFormGroup = ({ label, children, required, }) => {
    return (react_1.default.createElement(reactstrap_1.FormGroup, null,
        react_1.default.createElement(reactstrap_1.Label, null,
            label,
            ' ',
            react_1.default.createElement(react_if_1.When, { condition: !!required },
                react_1.default.createElement("sup", { style: { marginLeft: 0 } },
                    react_1.default.createElement(react_2.OsmosysIcon, { tooltip: "Required", tooltipSpan: true, osysIcon: "required", className: "text-danger", iconStyle: "solid", size: "sm" })))),
        children));
};
//# sourceMappingURL=index.js.map